<template>
  <div class="login-page-container">
    <div class="bg">
      <div class="auth-box-w">
        <div class="logo-w">
          <!-- <img alt src="../assets/logo.png" /> -->
          <h2>全生命周期管理系统</h2>
        </div>

        <el-tabs v-model="loginType" class="login-tabs">
          <el-tab-pane label="密码登录" name="pswd">
            <form @submit.prevent="handlePswdLogin">
              <div class="form-group">
                <label for>手机号</label>
                <input
                  class="form-control"
                  v-model="mobile"
                  maxlength="11"
                  placeholder="输入您的手机号码"
                />
                <div class="pre-icon os-icon os-icon-user-male-circle"></div>
              </div>
              <div class="form-group">
                <label for>密码</label>
                <input
                  class="form-control"
                  v-model="password"
                  placeholder="请输入密码"
                  type="password"
                />
                <div class="pre-icon os-icon os-icon-fingerprint"></div>
              </div>
              <div class="form-group">
                <label for>验证码</label>
                <div class="captcha">
                  <input
                    class="form-control"
                    v-model="captcha"
                    placeholder="请输入验证码"
                  />
                  <img :src="captchaImageUrl" @click="reloadCaptchaImageUrl" />
                </div>
              </div>
              <div class="buttons-w">
                <button :disabled="submiting" class="btn btn-primary">
                  登 录
                </button>
              </div>
            </form>
          </el-tab-pane>
          <!-- <el-tab-pane label="短信登录" name="code">
            <form @submit.prevent="handleCodeLogin">
              <div class="form-group">
                <label for>手机号</label>
                <input
                  class="form-control"
                  v-model="mobile"
                  maxlength="11"
                  placeholder="输入您的手机号码"
                />
                <div class="pre-icon os-icon os-icon-user-male-circle"></div>
              </div>
              <div class="form-group">
                <label for>短信验证码</label>
                <div class="flex-row-between">
                  <input
                    style="flex: 1"
                    v-model="code"
                    class="form-control"
                    placeholder="请输入短信验证码"
                    type="text"
                  />
                  <el-button
                    :disabled="inMsgCD"
                    class="ml-10"
                    style="width: 102px"
                    size="medium"
                    type="text"
                    @click="sendMsg"
                  >
                    {{
                      inMsgCD ? msgCoundDown + ' 秒后可重发' : '获取短信验证码'
                    }}
                  </el-button>
                </div>

                <div class="pre-icon os-icon os-icon-mail"></div>
              </div>
              <div class="buttons-w">
                <button :disabled="submiting" class="btn btn-primary">
                  登 录
                </button>
              </div>
            </form>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>

    <div class="beian-info">
      &#0169; {{ new Date().getFullYear() }} 奥瑞拓能源
    </div>
  </div>
</template>

<script>
import store from '@/store/index'
import { host } from '@/config/env.js'
import {
  mobileCode,
  mobileLoginPost,
  passwdLoginPost,
  getCaptcha,
} from '@/service/getData'

export default {
  data() {
    return {
      loginType: 'pswd',
      mobile: '',
      password: '',
      submiting: false,
      captcha: null,
      captchaId: null,
      code: null,
      captchaImageUrl: null,
      inMsgCD: false,
      msgButtonTitle: '获取短信验证码',
      msgTimer: null,
      msgCoundDown: 60,
    }
  },
  created() {
    this.loadCaptcha()
  },
  methods: {
    async loadCaptcha() {
      let res = await getCaptcha()
      this.captchaId = res.data.captchaId
      this.captchaImageUrl = host + res.data.imageUrl
    },
    reloadCaptchaImageUrl() {
      this.captchaImageUrl += '?reload=true'
    },
    async handlePswdLogin() {
      if (!this.mobile || this.mobile.length != 11) {
        this.$message.error('手机号错误')
        return
      }

      if (!this.password) {
        this.$message.error('密码不能为空')
        return
      }

      if (!this.captcha) {
        this.$message.error('验证码不能为空')
        return
      }

      this.submiting = true
      let res = await passwdLoginPost({
        token_validate: false,
        mobile: this.mobile,
        password: this.password,
        captchaId: this.captchaId,
        captcha: this.captcha,
      })

      if (res.code == 0) {
        this.loginHandle(res)
      } else {
        this.loadCaptcha()
      }
      this.submiting = false
    },
    async handleCodeLogin() {
      this.submiting = true

      let res = await mobileLoginPost(this.mobile, parseInt(this.code))
      if (res.code == 0) {
        this.loginHandle(res)
      }
      this.submiting = false
    },
    loginHandle(res) {
      store.commit('login', res.data)
      if (res.data.default_pswd) {
        this.$router.push('/setpswd')
      } else {
        if (store.state.loginRedirect) {
          this.$router.push(store.state.loginRedirect)
        } else {
          this.$router.push('/dashboard')
        }
      }
    },
    async sendMsg() {
      if (this.mobile.length != 11) {
        this.$message.error('请填入正确的手机号')
        return
      }
      let res = await mobileCode(this.mobile)
      if (res.code == 0) {
        this.$message.success('短信已发送')
        this.inMsgCD = true
        this.msgTimer = setInterval(this.runMsgCoundDown, 1000)
      }
    },
    runMsgCoundDown() {
      this.msgCoundDown--
      if (this.msgCoundDown < 0) {
        this.inMsgCD = false
        this.msgCoundDown = 60
        clearInterval(this.msgTimer)
      }
    },
  },
  beforeDestroy() {
    if (this.msgTimer) {
      clearInterval(this.msgTimer)
    }
  },
}
</script>

<style  scoped>
.auth-box-w {
  max-width: 450px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1);
}

.auth-box-w.wider {
  max-width: 500px;
}

.auth-box-w .logged-user-w {
  padding-top: 0px;
  padding-bottom: 10px;
}

.auth-box-w .logo-w {
  text-align: center;
  padding: 10%;
}

.auth-box-w .auth-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 1rem;
  margin-bottom: 2rem;
  position: relative;
  z-index: 1;
  padding-left: 80px;
}

.auth-box-w .auth-header:after {
  content: '';
  background-color: #047bf8;
  width: 32px;
  height: 7px;
  border-radius: 2px;
  display: block;
  position: absolute;
  bottom: -4px;
  left: 80px;
}

.auth-box-w form {
  padding: 20px 80px;
  padding-bottom: 60px;
}

.auth-box-w form .form-check-inline {
  margin-left: 1rem;
}

.auth-box-w form .form-group {
  position: relative;
}

.auth-box-w form .form-group .pre-icon {
  position: absolute;
  bottom: 5px;
  font-size: 24px;
  color: #047bf8;
  left: -38px;
}

.auth-box-w .buttons-w {
  padding-top: 1rem;
  margin-top: 0.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.auth-box-w.centered {
  text-align: center;
}

.auth-box-w.centered .auth-header {
  padding-left: 0px;
}

.auth-box-w.centered .auth-header:after {
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  left: 50%;
}

.flex-row-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-control {
  height: 36px;
}
.login-page-container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}

.login-page-container .bg {
  margin-top: 40px;
  /* background-image: url(../../assets/bg-pattern2.png);
  background-size: contain;
  background-repeat: repeat;
  background-position: 0 0; */
}
.login-page-container:before {
  content: '';
  position: absolute;
  z-index: -1;
  background-color: #f2f4f7;
  /* background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    from(#ffffff),
    to(#3082f8)
  );
  background: linear-gradient(to bottom right, #ffffff, #3082f8); */
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
}
.captcha {
  display: flex;
}
.captcha img {
  width: 38%;
  height: intrinsic;
  margin-left: 8%;
  margin-right: 4%;
}
.logo-w {
  display: flex;
  justify-content: center;
  align-items: bottom;
}
.logo-w h2 {
  font-weight: bold;
  font-size: 26px;
  margin-left: 8px;
  margin-top: 2px;
}
.logo-w img {
  width: 113px;
  height: 32px;
}
label {
  margin-bottom: 4px;
}
/deep/ .login-tabs .el-tabs__nav-scroll {
  padding: 0 80px !important;
}

/deep/ .login-tabs .el-tabs__item.is-active {
  color: #292b2c;
  font-size: 16px;
}
/deep/ .login-tabs .el-tabs__item {
  color: #636c72;
}
.beian-info {
  color: #999;
  opacity: 0.5;
  position: absolute;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
}
</style>